/**
 * Auto-registration entry point for el-dm-nested-menu
 *
 * Import this module to automatically register the custom element:
 * import '@duskmoon-dev/el-nested-menu/register';
 */

import { register } from './el-dm-nested-menu.js';

register();
